"use strict";
/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinPathParts = exports.toPathParts = exports.getPathsOfLevels = exports.pushPath = exports.popPath = exports.computePathAfterPatch = exports.mergePatches = exports.findConflicts = exports.memoWithWeakMap = exports.isPlainObject = exports.computeArrayReuseMap = exports.cloneDeep = exports.diff = exports.applyPatches = exports.DataMapper = void 0;
var DataMapper_1 = require("./DataMapper");
Object.defineProperty(exports, "DataMapper", { enumerable: true, get: function () { return DataMapper_1.DataMapper; } });
var applyPatches_1 = require("./utils/applyPatches");
Object.defineProperty(exports, "applyPatches", { enumerable: true, get: function () { return __importDefault(applyPatches_1).default; } });
var diff_1 = require("./utils/diff");
Object.defineProperty(exports, "diff", { enumerable: true, get: function () { return __importDefault(diff_1).default; } });
var cloneDeep_1 = require("./utils/cloneDeep");
Object.defineProperty(exports, "cloneDeep", { enumerable: true, get: function () { return __importDefault(cloneDeep_1).default; } });
var computeArrayReuseMap_1 = require("./utils/computeArrayReuseMap");
Object.defineProperty(exports, "computeArrayReuseMap", { enumerable: true, get: function () { return __importDefault(computeArrayReuseMap_1).default; } });
var isPlainObject_1 = require("./utils/isPlainObject");
Object.defineProperty(exports, "isPlainObject", { enumerable: true, get: function () { return __importDefault(isPlainObject_1).default; } });
var memoWithWeakMap_1 = require("./utils/memoWithWeakMap");
Object.defineProperty(exports, "memoWithWeakMap", { enumerable: true, get: function () { return __importDefault(memoWithWeakMap_1).default; } });
var findConflicts_1 = require("./utils/findConflicts");
Object.defineProperty(exports, "findConflicts", { enumerable: true, get: function () { return findConflicts_1.findConflicts; } });
var mergePatches_1 = require("./utils/mergePatches");
Object.defineProperty(exports, "mergePatches", { enumerable: true, get: function () { return __importDefault(mergePatches_1).default; } });
var path_1 = require("./utils/path");
Object.defineProperty(exports, "computePathAfterPatch", { enumerable: true, get: function () { return path_1.computePathAfterPatch; } });
Object.defineProperty(exports, "popPath", { enumerable: true, get: function () { return path_1.popPath; } });
Object.defineProperty(exports, "pushPath", { enumerable: true, get: function () { return path_1.pushPath; } });
Object.defineProperty(exports, "getPathsOfLevels", { enumerable: true, get: function () { return path_1.getPathsOfLevels; } });
Object.defineProperty(exports, "toPathParts", { enumerable: true, get: function () { return path_1.toPathParts; } });
Object.defineProperty(exports, "joinPathParts", { enumerable: true, get: function () { return path_1.joinPathParts; } });
// 导出的类型
__exportStar(require("./PatchOp"), exports);
__exportStar(require("./MapRule"), exports);
